import { Directive, ElementRef, Input, Output, EventEmitter } from "@angular/core";
import { Scoutview } from "@models";

@Directive({
  standalone: false,
  selector: '[svLazyThumbnail]'
})
export class SvLazyThumbnailDirective {
  @Input() svLazyThumbnail = null;

  @Output() downloadImage: EventEmitter<Scoutview> = new EventEmitter();
  @Output() clearImage: EventEmitter<Scoutview> = new EventEmitter();

  isElementVisible = false;
  
  constructor(private el: ElementRef) {
  }

  ngAfterViewInit() {
    const observedElement = this.el.nativeElement.parentElement;

    const observer = new IntersectionObserver(([entry]) => {
      this.checkImage(entry.isIntersecting);
    });
    
    observer.observe(observedElement);
  }

  checkImage(isIntersecting: boolean) {
    if (isIntersecting) {
      this.downloadImage.emit(this.svLazyThumbnail);
    } else {
      this.clearImage.emit(this.svLazyThumbnail);
    }
  }
}